import { Callout } from "@blueprintjs/core";
import css from "./ScenarioValidityWarning.module.scss";

interface ScenarioValidityWarningProps {
    msg: string | null;
}

const ScenarioValidityWarning: React.FC<ScenarioValidityWarningProps> = (
    props
) => {
    if (props.msg !== null) {
        return (
            <Callout intent="warning" className={css["scenario-warning"]}>
                {" "}
                {props.msg}{" "}
            </Callout>
        );
    } else {
        return <div></div>;
    }
};

export default ScenarioValidityWarning;
